/* ------------------------------------------------------------------
   Moves the Shop by brands rail into the collection product grid so it
   sits directly after three full rows of products.

   The grid is 2 / 4 / 6 columns depending on the screen, so three rows
   is 6 / 12 / 18 products. Rather than hard-coding that, the column
   count is read back off the live grid and the rail is re-placed
   whenever the window is resized.
------------------------------------------------------------------- */
(function () {
  var ROWS = 3;
  var GRID = '[data-coll-grid]';
  var RAIL = '[data-brand-rail]';

  function columns(grid) {
    var tpl = window.getComputedStyle(grid).getPropertyValue('grid-template-columns');
    if (!tpl || tpl === 'none') return 0;
    return tpl.trim().split(/\s+/).length;
  }

  function place() {
    var rail = document.querySelector(RAIL);
    if (!rail) return;

    var grid = document.querySelector(GRID);
    if (!grid) { rail.classList.add('is-placed'); return; }

    var cols = columns(grid);
    if (!cols) { rail.classList.add('is-placed'); return; }

    var cards = Array.prototype.filter.call(grid.children, function (el) {
      return el !== rail;
    });

    var at = cols * ROWS;

    if (cards.length <= at) {
      // Fewer than three rows on this page — let it close out the grid.
      if (grid.lastElementChild !== rail) grid.appendChild(rail);
    } else if (rail.nextElementSibling !== cards[at]) {
      grid.insertBefore(rail, cards[at]);
    }

    rail.classList.add('is-placed');
  }

  function start() {
    var rail = document.querySelector(RAIL);
    if (!rail) return;

    // Page two onwards is a continuation of the same list, so the rail
    // belongs on the first page only.
    var page = new URLSearchParams(window.location.search).get('page');
    if (page && parseInt(page, 10) > 1) {
      rail.parentNode.removeChild(rail);
      return;
    }

    place();

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(place, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
